import { j as attr, p as pop, b as push } from "../../../chunks/hooks.server.js";
import "../../../chunks/client.js";
import { F as Fa } from "../../../chunks/fa.js";
/* empty css                                                           */
import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import "../../../chunks/index2.js";
import { B as Button } from "../../../chunks/button.js";
function _page($$payload, $$props) {
  push();
  let username = "";
  let isLoading = false;
  $$payload.out += `<div class="min-h-screen bg-[#111111] flex flex-col"><div class="w-full pt-16"><img src="/images/logos/porsche-logo.png" alt="Porsche Albania" class="h-12 mx-auto"></div> <div class="flex-1 flex items-center justify-center px-4"><div class="w-full max-w-xl space-y-32"><div class="text-center"><h1 class="text-4xl font-medium text-white tracking-wide">Si quheni?</h1></div> <form class="space-y-6"><div class="space-y-4"><div class="flex flex-col items-center gap-8"><input type="text"${attr("value", username)} placeholder="Emri i përdoruesit" class="w-full max-w-lg h-12 px-0 bg-transparent border-0 border-b border-neutral-700 text-white placeholder-neutral-500 focus:outline-none focus:border-neutral-300 transition-all text-lg text-center font-light tracking-wider caret-white" style="--tw-ring-color: transparent;"> `;
  Button($$payload, {
    type: "submit",
    variant: "ghost",
    size: "sm",
    class: "h-10 px-6 rounded bg-white hover:bg-neutral-100 text-sm text-black font-light tracking-wide flex items-center gap-2",
    disabled: isLoading,
    children: ($$payload2) => {
      {
        $$payload2.out += "<!--[!-->";
        $$payload2.out += `Dakord `;
        Fa($$payload2, { icon: faRightToBracket });
        $$payload2.out += `<!---->`;
      }
      $$payload2.out += `<!--]-->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div> `;
  {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--></div></form></div></div></div>`;
  pop();
}
export {
  _page as default
};
